export class ResponseModel {
    success: boolean;
    data: string[];
    errors: { [property: string]: string };
    /**
     *
     */
    constructor(response:ResponseModel) {
       
        this.success=response.success;
        this.data=response.data;
        this.errors=response.errors;
    }
}